import axios from 'axios'

export default {
  // resolves to { filed, url, asReporter }; filed is false outside production
  submit (context, report) {
    return axios.post('/api/bug', report).then(({ data }) => data)
  }
}
